import React, { Component } from 'react';

class ProviderHelper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sidebarHasBeenLoaded: false
    }
  }

  render() {
    return (
      <div>
        {React.cloneElement(this.props.children, {sidebarHasBeenLoaded: this.state.sidebarHasBeenLoaded})}
      </div>
    )
  }
}

export { ProviderHelper as Provider };